export const SET_COOKIE_BANNER = 'cookie/SET_COOKIE_BANNER';
export const RESET_STATE = 'cookie/RESET_STATE';
